export default __webpack_public_path__ + "static/media/fallible-site-sm.f0d278f2.jpg";